import { Expose, Type } from "class-transformer";
import type { RealEstateBuildingMacroCategoryEnum } from "../../../../features/profile/constants/real-estate/real-estate-building-macro-category.enum";
import type { RealEstateBuildingTypeEnum } from "../../../../features/profile/constants/real-estate/real-estate-building-type.enum";
import type { RealEstateCategoryEnum } from "../../../../features/profile/constants/real-estate/real-estate-category.enum";
import { RealEstateRelationshipDto } from "./real-estate-relationship.dto";

export class RealEstateDto {
  @Expose()
  id?: string;

  @Expose()
  realEstateCategory?: RealEstateCategoryEnum;

  @Expose()
  realEstateBuildingMacroCategory?: RealEstateBuildingMacroCategoryEnum;

  @Expose()
  realEstateBuildingType?: RealEstateBuildingTypeEnum;

  @Expose()
  realEstateGeographyCountry?: string;

  @Expose()
  realEstateGeographyMunicipality?: string;

  @Expose()
  realEstateGeographyProvince?: string;

  @Expose()
  realEstateGeographyRegion?: string;

  @Expose()
  @Type(() => RealEstateRelationshipDto)
  relationship?: RealEstateRelationshipDto;

  @Expose()
  realEstateLabel?: string;

  @Expose()
  isComplete!: boolean;
}
